// extracted by mini-css-extract-plugin
module.exports = {"dialog":"yaml-editor__dialog--3Bl5l","yaml_editor_container":"yaml-editor__yaml_editor_container--3rCEz","ace_editor":"yaml-editor__ace_editor--1R_Jx"};